// components/common/Loader.jsx
import React from 'react';

const CommonLoader = ({ 
  size = 'md', 
  color = 'primary', 
  fullScreen = false,
  message = '',
  className = '' 
}) => {
  const sizeClasses = {
    xs: 'h-6 w-6',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const colorClasses = {
    primary: 'border-primary border-r-transparent text-primary',
    secondary: 'border-secondary border-r-transparent text-secondary',
    success: 'border-success border-r-transparent text-success',
    danger: 'border-danger border-r-transparent text-danger',
    warning: 'border-warning border-r-transparent text-warning',
    gray: 'border-gray-400 border-r-transparent text-gray-400'
  };

  return (
    <div className={`
      ${fullScreen ? 'fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50' : 'flex items-center gap-3'}
      ${className}
    `}>
      <div 
        className={`
          inline-block ${sizeClasses[size]} animate-spin rounded-full border-4 border-solid border-current ${colorClasses[color]}
          align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]
        `}
        role="status"
        aria-label="loading"
      >
        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
          Loading...
        </span>
      </div>
      
      {message && (
        <span className="text-sm font-medium text-textcolor tracking-[0] leading-[normal]">
          {message}
        </span>
      )}
    </div>
  );
};

export default CommonLoader;
